<template>
  <div >
    <div class="flex-col">
      <div class="flex-col">
        <div class="flex items-center py-1">
          <p class="font-bold">
            CPF/CNPJ:
            <span class="font-normal" v-text="contaBancaria.cpf_cnpj" />
          </p>
        </div>
        <div class="flex items-center py-1">
          <p class="font-bold">
            Banco:
            <span class="font-normal"
              >{{ lynxPadStart(contaBancaria.banco.id) }} -
              {{ contaBancaria.banco.nome }}</span
            >
          </p>
        </div>
        <div class="flex items-center py-1">
          <p class="font-bold">
            Conta:
            <span class="font-normal">
              {{ contaBancaria.conta }}
              <span
                v-if="contaBancaria.dv_conta"
                v-text="` - ${contaBancaria.dv_conta}`"
              />
            </span>
          </p>
        </div>
        <div class="flex items-center py-1 font-light">
          <p class="font-bold">
            Agência:
            <span class="font-normal">
              {{ contaBancaria.agencia }}
              <span
                v-if="contaBancaria.dv_agencia"
                v-text="` - ${contaBancaria.dv_agencia}`"
              />
            </span>
          </p>
        </div>
        <div class="flex items-center py-1 font-light">
          <p class="font-bold">
            Pix:
            <span class="font-normal">
              {{ contaBancaria.pix }}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { lynxPadStart } from "@/utils/utils";

export default {
  props: {
    contaBancaria: { required: true },
  },

  methods: {
    lynxPadStart,
  },
};
</script>